import SummaryType from "state/selections/Constants/SummaryType";
import scope from "state/cf/scope";

export default class DurationToTargetDefinition {
  static getDefault = () =>
    new DurationToTargetDefinition({
      summary: SummaryType.ABSOLUTE,
    });

  #summary;

  constructor(props = {}) {
    const { summary } = props;

    this.#summary = summary;
  }

  get summary() {
    return this.#summary;
  }

  setSummary = (value) =>
    new DurationToTargetDefinition({
      summary: value,
    });

  get key() {
    return `${scope} - ${this.#summary}`;
  }

  get complete() {
    return true;
  }

  copy = () => {
    return {
      summary: this.summary,
    };
  };
}
